import './tooltip.scss';

export default {
  tooltip: 'portal-tooltip',
  tooltipText: 'portal-tooltip-text',
  icon: 'glyphicon glyphicon-info-sign',
}



// WEBPACK FOOTER //
// src/common/tooltip-display/tooltip.style.js